import BaseDTO from '../base/BaseDTO';
import Dealership from '../dealership/Dealership';
import StudioState from './StudioState';

export default class Studio extends BaseDTO {
    public uuid: string | undefined;
    public name: string | undefined;
    public hostname: string | undefined;
    public rcpsPlayerId: number | undefined;
    public lastHeartbeat: string | undefined;
    public state: StudioState | StudioState.UNINITIALIZED;
    public dealership: Dealership | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.uuid = data['uuid'] || undefined;
        this.name = data['name'] || undefined;
        this.hostname = data['hostname'] || undefined;
        this.rcpsPlayerId = data['rcpsPlayerId'] || undefined;
        this.lastHeartbeat = data['lastHeartbeat'] || undefined;
        this.state = data['state'] || StudioState.UNINITIALIZED;
        this.dealership = data['dealership'] ? new Dealership(data['dealership']) : undefined;
    }
}
